import { useEffect, useState } from "react";
import { get_favourites } from "../../../server/requests";
import RowList from "../../Row_List/RowList";
import Loading from "../../Loading/Loading";
import { translateWord } from "../../Util/util";
import favorite_outline from '../../pages_child/InfoMovie/images/favourite.png'

export default function Favourites({ isGuest }) {
    const [listFavourites, setListFavourites] = useState([])
    const [showLoading, setShowLoading] = useState(false)
    const [isEmpty, setIsEmpty] = useState(false)

    useEffect(() => {
        setShowLoading(true)
        get_favourites({}, data => {
            setListFavourites([...data])
            setShowLoading(false)
            const empty = data.some((e) => e.content.length != 0)
            setIsEmpty(empty)
        }, err => {
            console.log(err)
            setShowLoading(false)

        })
    }, [])

    return (
        <div className="container">
            <div className="list_favourites">

                {
                    <>
                        {showLoading ?
                            <Loading />
                            : isEmpty ? listFavourites.map((row, index) => {
                                return row.content && row.content.length ?
                                    <RowList
                                        key={row.id}
                                        title={row.title}
                                        type={row.type}
                                        row={row}
                                        array={row.content}
                                        rowIndex={index}
                                        isGuest={isGuest}

                                    /> : null
                            }) : <div className="isEmpty_Favourites">
                                <img src={favorite_outline} className='favorite_img' />
                                <p>
                                    {isGuest ? translateWord('You must be sign in, for access this feature', 'You must be sign in, for access this feature') : translateWord('Favorite list is empty', 'Favorite list is empty')}
                                </p>
                            </div>
                        }
                    </>

                }

            </div>
        </div>
    )
}